module.exports = __webpack_public_path__ + "img/window_title_prize.e3255ea1.png";